import { store } from '@redux/store';
import modalService from 'layout/services/modalService';
import { closeModalSvg, thankYouEmail, thankYouPhone, thankYouSuccess } from '../constants/svgIcons';

export default class ThankScreenBasic {
  constructor() {
    const state = store.getState();
    this.url = state?.uiState?.modalInformation?.url;
    this.builderName = state?.uiState?.modalInformation?.listingInformation?.brandName ?? 'the builder';
    this.closeAttribute = '[data-close]';
    this.thankYouSuccess = thankYouSuccess;
    this.closeModalSvg = closeModalSvg;
  }

  /**
   * Sets the internal browsing anchor for the ThankScreenBasic component.
   * @param {object} anchor - The anchor to be set (CreateAccountAnchor or ReturnToSearchAnchor).
   */
  setInternalBrowsingAnchor(anchor) {
    this.internalBrowsingAnchor = anchor;
  }

  /**
   * Binds events to the ThankScreenBasic component.
   * @function bindEvents
   * @memberof ThankScreenBasic
   * @instance
   */
  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenBasic.closeModal));

    this.internalBrowsingAnchor?.bindEvents?.();
  }

  static closeModal() {
    modalService.clearHtml();
  }

  getHtml() {
    return `
    <div class="lead-form form--thanks">
      <button class="modal__close" data-close>
        ${this.closeModalSvg}
      </button>
      <div class="thanks__content">
      ${thankYouSuccess}
        <p class="thanks__title">Way to Go!</p>
        <p class="thanks__text" data-qa="firstmsg">
          An agent will be in contact soon!
        </p>
      </div>
      <div class="thanks__footer">
        <p class="thanks__footer-title">What’s Next?</p>
        <div class="thanks__footer-container">
          <p class="thanks__footer-text" data-qa="ThankYouPhone">${thankYouPhone} Builders will reach out to answer any questions you may have</p>
          <div class="thanks__footer-paragraph" data-qa="ThankYouEmail">
            ${thankYouEmail} 
            <div>
              <p>You've also unlocked access to our New Homes Insider</p>
              <ul>
                <li>Weekly email, our collection of new home listings in your area</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="thanks__progress" data-qa="ThanksProgress"></div>
      </div>
      <div class="form__button-bar thanks__button-bar">
        ${this.internalBrowsingAnchor.getHtml()}
      </div>
    </div>`;
  }
}